export default "__VITE_ASSET__CPLTHHt0__"